import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject } from 'rxjs';

import { GpFundraisingDataService } from 'src/app/services/gp/gp-fundraising-data.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'terra-export-fundraisings-menu',
  templateUrl: './export-fundraisings-menu.component.html',
  styleUrls: ['./export-fundraisings-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportFundraisingsMenuComponent extends OnDestroyMixin implements OnInit {

  @Input() holdingId: number = null;

  @Input() fundraisingId: number = null;

  public isExporting$ = new BehaviorSubject(false);

  constructor(
    private fundraisingsDataService: GpFundraisingDataService,
    private utilsService: UtilsService,
    private snackbarService: SnackbarService) {
    super();
  }

  ngOnInit(): void {
  }

  exportFundraisings(fileType: "excel" | "csv") {
    this.isExporting$.next(true);
    this.fundraisingsDataService
      .exportFundraisings(fileType, this.holdingId, this.fundraisingId)
      .pipe(untilComponentDestroyed(this))
      .subscribe(
        fileUrl => {
          if (!!fileUrl) {
            this.utilsService.downloadFileFromUrl(fileUrl);
          }
          this.isExporting$.next(false);
        },
        error => {
          this.snackbarService.showGeneralMessage("Failed exporting distributions. Please contact support.");
          this.isExporting$.next(false);
        }
      );
  }
}
